module.exports = __webpack_public_path__ + "img/product_0.a477ab5.webp";